// Module
var code = "<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\"> <rect height=\"3.5\" width=\"12.5\" y=\"2.75\" x=\"1.75\"/> <path d=\"m6.75 9.25h2.5m-6.5-2.5v7.5h10.5v-7.5\"/> </svg>";
// Exports
module.exports = code;